import { ChangeDetectionStrategy, Component } from "@angular/core";

/* eslint-disable @tseslint/no-extraneous-class */
@Component({
  selector: "app-authenticate-ui-headline-title",
  templateUrl: "headline-title.component.html",
  styleUrl: "headline-title.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class HeadlineTitleComponent {}
/* eslint-enable @tseslint/no-extraneous-class */
